import { createContext, useContext } from "react"
import { ShopConsentCategories } from "types/consent"

interface ShopCookieConsentContextValue {
  /** Whether the shop has any tracking configured */
  hasTrackingConfig: boolean
  /** Reopen the consent banner to change settings */
  reopenBanner: () => void
  /** Accept consent with specific categories */
  acceptConsent: (categories: ShopConsentCategories) => void
  /** Reject all consent */
  rejectConsent: () => void
}

const ShopCookieConsentContext = createContext<ShopCookieConsentContextValue | null>(null)

export const ShopCookieConsentProvider = ShopCookieConsentContext.Provider

export function useShopCookieConsentContext(): ShopCookieConsentContextValue | null {
  return useContext(ShopCookieConsentContext)
}
